import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Input from '../../../../components/Input';
import Label from '../../../../components/Label';
import messages from './messages';
import rootMessages from '../messages';

import '../styles.css';

const ErrorLabel = (
  <Label
    role="tooltip"
    basic
    color="red"
    pointing
  >
    <FormattedMessage {...rootMessages.invalidError} />
  </Label>
);

const ScoolSize = ({ onChange, initialValue, ...rest }) => (
  <React.Fragment>
    {
        Object.keys(initialValue).filter((k) => initialValue[k]).map((key) => {
          const { value: iValue, showError } = initialValue[key];
          return (
            <div styleName="field" key={key}>
              <Label styleName="menu-field-label" as="label" htmlFor={key}>
                <FormattedMessage {...messages[key]} />
              </Label>
              <Input
                fluid
                type="number"
                min="0"
                id={key}
                value={iValue}
                onChange={(e, { value }) => {
                  onChange(e, {
                    [key]: { ...initialValue[key], value },
                  });
                }}
              />
              { showError && ErrorLabel }
            </div>
          );
        })
      }
  </React.Fragment>
);

ScoolSize.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default ScoolSize;
